import React from "react";
import { ChevronLeft } from "../../assets/svgs";
import useApp from "../../hooks/useApp";
import "./styles.scss";

const Header = ({
  icon = ChevronLeft,
  onClick,
  rightIcon,
  onClickRightIcon,
  containerStyle,
  backEnable = false,
  rightIconStyle = {},
}) => {
  const { isRTL } = useApp();
  return (
    <div className={`header-container ${containerStyle}`}>
      {backEnable ? (
        <img
          src={icon}
          onClick={onClick}
          alt="header-icon"
          className={isRTL ? "header-icon-rtl" : "header-icon"}
        />
      ) : null}
      {rightIcon ? (
        <img
          src={rightIcon}
          onClick={onClickRightIcon}
          alt="header-right-icon"
          className={isRTL ? "header-right-icon-rtl" : "header-right-icon"}
          style={rightIconStyle}
        />
      ) : null}
    </div>
  );
};

export default Header;
